import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { pick } from '@eastcoal/common/utils/object'

import { Select } from '@eastcoal/formily/components/Select'

import { RealBizTypeOptions } from '@eastcoal/shared/enums/BizType'

export const BizTypeSelect = () => {
  const { request } = useRemoteTableStore(state => pick(state, ['request']))

  const onBizTypeChange = (value: number) => {
    request({ bizType: value })
  }

  return (
    <Select
      options={RealBizTypeOptions}
      placeholder='冻结类型'
      style={{ width: 160 }}
      onChange={onBizTypeChange}
    />
  )
}
